module.exports = __webpack_public_path__ + "img/collective.0334803e.gif";